import React from 'react';
import isBefore from 'date-fns/isBefore';
import moment from 'moment';

import { connect } from 'react-redux';
import { Action } from 'redux';
import { Button } from 'antd';
import { ThunkDispatch } from 'redux-thunk';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { isEmpty } from 'lodash';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { v4 } from 'uuid';
import { Base64 } from 'js-base64';

import {
  condoFlexibleDatePickerActions,
  CondoGuestInitialState,
  condoGuestsActions,
  condosActions,
  condosLocationPickerActions,
  condoStrictDatesActions,
  getCondos,
  ICondoFlexibleDatePickerState,
  ICondoGuestsState,
  ICondosLocationPickerState,
  ICondosState,
  ICondoStrictDatesState,
  IHotelsState,
  IMenuState,
  ICertificatesState,
} from '@share/store/slices';
import {
  getDateCheckInOut,
  GetDisableNewTabOpen,
  GetMultipleCitiesEnabled,
  GetMultipleQuotesEnabled,
  getPreferenceFileUrlFromAccount,
  getPreferenceFromAccount,
  GetStyles,
  isCondoDataValid,
  isSpanish,
  RootState,
  persistCondoCertificateSelectionToStorage,
  filterUserCertificatesByTypeAndStatus,
  findCertificateItemIdForItemType,
  findUserCertificateById,
  fetchCondoLocationForCertificateBootstrap,
  isDisplayCertificates,
  getTotalNightsForCertificateItemType,
  Toaster,
  getNights,
} from '@share/utils';
import { AccessToken, BlueButton, SearchSelection } from '@share/components';
import { disableAnytimeSearchWarning } from '@share/utils';
import { getTimeout, UrlUtils } from '@share/utils';
import {
  CONDO_DATES_FLEXIBLE_LABEL,
  CONDO_DATES_LABEL,
  CONDO_GUESTS_LABEL,
  CONDO_IS_FLEXIBLE_LABEL,
  CONDO_LOCATIONS_LABEL,
  CONDO_LOCATIONS_OBJECT_LABEL,
  CONDO_SEARCH_BOUNDS,
  CONDO_FILTERS_LABEL,
  CONDO_SESSION_KEY,
  DEFAULT_PAGE_NUMBER,
  REFERENCE_NUMBER_LABEL,
  AGENCY_NUMBER_LABEL,
  Routes,
  ACCESS_TOKEN_LABEL,
} from '@share/constants';
import {
  CondoLocationsEnum,
  CONDOS_BACKGROUND_PHOTO_FIELD_KEY,
  CONDOS_SEARCH_MESSAGE_FIELD_KEY,
  CONDOS_SEARCH_TITLE_FIELD_KEY,
  DateSearchTypeEnum,
  IAccount,
  IBounds,
  ICondoLocation,
  ISessionKey,
  ItemTypeEnum,
} from '@share/common-types';
import { SearchTypeEnum, StayForEnum, IShareCompareState } from '@share/common-types';
import { condoFiltersActions, ICondoFiltersState, ILoginState } from '@share/store/slices';
import { Responsive, LoginType } from '@share/utils';

import { CondoGuestsPicker } from '../condo-guests-picker';
import { CondoStrictDatePicker } from '../condo-strict-date-picker';
import { CondoSearchInfo } from '../condo-search-info';
import { CondoLocationPicker } from '../condo-location-picker';

import { UNDEFINED_VALUE } from '@constants';

import HotelBackground from '@share/assets/images/hotel/bg-hotels.png';
import CondoBackground from '@share/assets/images/condo/bg-condo.jpg';

import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotate, faSearch } from '@fortawesome/free-solid-svg-icons';
import { compareActions } from '@share/store/slices';
import { UserCertificatesFetcher } from '../../certificates';

interface IMapStateToProps {
  condosStore: ICondosState;
  condosLocationPickerStore: ICondosLocationPickerState;
  condoStrictDatesStore: ICondoStrictDatesState;
  condoGuestsStore: ICondoGuestsState;
  condoFlexibleDatePickerStore: ICondoFlexibleDatePickerState;
  condoFiltersStore: ICondoFiltersState;
  certificatesStore: ICertificatesState;
  hotelsStore: IHotelsState;
  loginStore: ILoginState;
  menuStore: IMenuState;
  sharecompare: IShareCompareState;
}

interface IMapDispatchToProps {
  validateLocation: (error: string) => void;
  validateDates: (error: string) => void;
  setIsWidget: (isWidget: boolean) => void;
  setIsSearch: () => void;
  setPageNumber: () => void;
  setIsAnytimeSearchWarningVisible: (visible: boolean) => void;
  getCondos: (isReuse: boolean) => void;
  setShouldFocus: () => void;
  selectLocationLabel: (label: string) => void;
  selectLocation: (location: ICondoLocation) => void;
  setGuestsState: (state: ICondoGuestsState) => void;
  setFlexibleState: (state: ICondoFlexibleDatePickerState) => void;
  setSearchType: (type: DateSearchTypeEnum) => void;
  setDates: (dates: { startDate: string; endDate: string }) => void;
  setSessionKey: (sessionKey: ISessionKey) => void;
  setBounds: (bounds: IBounds) => void;
  setFilters: (filters: ICondoFiltersState) => void;
  resetFilters: () => void;
  resetDates: () => void;
  resetFlexibleState: () => void;
  setCondoCompareStartDate: (value: string) => void;
  setCondoCompareEndDate: (value: string) => void;
  setcondoscompareMonth: (value: string[]) => void;
  setcondoscompareSearch: (value: string) => void;
  setclearCondoCompare: () => void;
  setclearFullCondosCompare: () => void;
  setCondoCertificateId: (value: string) => void;
  setCondoCertificateItemId: (value: string) => void;
  setCondoCertificateAllowAutoFill: (allow: boolean) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps, WrappedComponentProps {
  isWidget?: boolean;
  isExperiences?: boolean;
  forceVertical?: boolean;

  title?: string;
  message?: string;
  hideTitle?: boolean;
  hideMessage?: boolean;
  hideSearchSelection?: boolean;
  widgetBackgroundColor?: string;
  widgetOriginalType?: string;
  borderRadius?: string;
  
  excludeCondosSelection?: boolean;
  excludeHotelsSelection?: boolean;
  excludeVacationsSelection?: boolean;
  disableLocationSearch?: boolean;

  onExperience?: () => void;

  onWidgetSelectionChange?: (value: string) => void;
}

interface IState {
  isCollapse: boolean;
  /** Bumped after certificate bootstrap writes strict dates so CondoStrictDatePicker remounts with store values (original picker only syncs on isInitial). */
  strictDatePickerRemountKey: number;
}

interface OnSearchOptions {
  isReuse?: boolean;
  isInit?: boolean;
  isLoad?: boolean;
  /** Merged onto props for this run (e.g. certificate bootstrap: connect props lag behind fresh dispatches). */
  locationPickerOverride?: Partial<ICondosLocationPickerState>;
}

const zero = 0;
const one = 1;

class CondoSearchComponent extends React.Component<IProps, IState> {
  state: IState = {
    isCollapse: false,
    strictDatePickerRemountKey: 0,
  };

  private condoCertificateRouteBootstrapped = false;

  private condoCertificateBootstrapInFlight = false;

  /**
   * URL middleware clears `condoFlexibleDates` during resetFlexibleState/setDates; `setSearchType(Flexible)` alone
   * does not republish them. Re-apply query params so `getCondoRequestDetail` / condos/details match Redux bootstrap.
   */
  private syncFlexibleCondoSearchUrlAfterCertificateBootstrap = (): void => {
    UrlUtils.removeFromUrl(CONDO_DATES_LABEL);
    UrlUtils.setUrl(CONDO_IS_FLEXIBLE_LABEL, one);
    UrlUtils.setUrl(CONDO_DATES_FLEXIBLE_LABEL, {
      selectedMonths: [],
      stayFor: StayForEnum.Week,
    });
  };

  private afterMountCondoCertificateSearch = async (params: { certificateId: string; isReuse: boolean }): Promise<void> => {
    const { certificateId, isReuse } = params;
    if (this.props.isWidget) {
      return;
    }
    const account = this.props.loginStore?.account as IAccount | undefined;
    if (!isDisplayCertificates(account)) {
      return;
    }
    if (!this.props.loginStore?.user?.userId || this.condoCertificateRouteBootstrapped) {
      return;
    }
    const { certificatesStore, condoFiltersStore } = this.props;
    if (certificatesStore.loading && certificatesStore.data.length === 0) {
      return;
    }
    if (this.condoCertificateBootstrapInFlight) {
      return;
    }
    this.condoCertificateBootstrapInFlight = true;
    try {
      const certs = filterUserCertificatesByTypeAndStatus(certificatesStore.data, ItemTypeEnum.Condo);
      const cert = findUserCertificateById(certs, certificateId);
      if (!cert) {
        return;
      }
      const certificateItemId = findCertificateItemIdForItemType(cert, ItemTypeEnum.Condo) ?? '';
      this.props.setCondoCertificateAllowAutoFill(true);
      this.props.setCondoCertificateId(certificateId);
      if (certificateItemId) {
        this.props.setCondoCertificateItemId(certificateItemId);
      }
      UrlUtils.setUrl(CONDO_FILTERS_LABEL, {
        ...condoFiltersStore,
        certificateId,
        certificateItemId: certificateItemId || condoFiltersStore.certificateItemId,
      });
      persistCondoCertificateSelectionToStorage({ certificateId, certificateItemId });
      // URL middleware: resetFlexibleState + setDates both force condoIsFlexible to '0' and strip flexible dates.
      // setSearchType(Flexible) must run last so the URL (and getCondoRequestDetail) end on flexible + condoFlexibleDates.
      this.props.resetFlexibleState();
      this.props.setDates({ endDate: UNDEFINED_VALUE, startDate: UNDEFINED_VALUE });
      this.props.setSearchType(DateSearchTypeEnum.Flexible);
      this.syncFlexibleCondoSearchUrlAfterCertificateBootstrap();
      this.setState((prev) => ({
        strictDatePickerRemountKey: prev.strictDatePickerRemountKey + 1,
      }));
      const nyLocation = await fetchCondoLocationForCertificateBootstrap();
      if (!nyLocation) {
        this.condoCertificateRouteBootstrapped = true;
        return;
      }
      this.props.selectLocation(nyLocation);
      this.props.selectLocationLabel(nyLocation.name ?? '');
      this.condoCertificateRouteBootstrapped = true;
      this.onSearch({
        isReuse,
        isLoad: true,
        isInit: true,
        locationPickerOverride: {
          selectedLocation: nyLocation,
          selectedLocationLabel: nyLocation.name ?? '',
        },
      });
      Toaster.info(this.props.intl.formatMessage({ id: 'certificates.bestValue.toast' }), { autoClose: 10000, toastId: 'certificates.bestValue.toast.condo' });
    } finally {
      this.condoCertificateBootstrapInFlight = false;
    }
  };

  componentDidMount() {
    const {
      isWidget,
      condosStore,
      setDates,
      selectLocation,
      selectLocationLabel,
      setSearchType,
      setGuestsState,
      setFlexibleState,
      setSessionKey,
      setBounds,
      setFilters,
      setIsWidget,
    } = this.props;

    if (isWidget) {
      setIsWidget(isWidget);
    }

    const values = UrlUtils.getValues();
    let isReuse = false;

    if (values[CONDO_FILTERS_LABEL]) {
      setFilters(values[CONDO_FILTERS_LABEL] as ICondoFiltersState);
    }

    if (values[CONDO_SEARCH_BOUNDS]) {
      setBounds(values[CONDO_SEARCH_BOUNDS] as IBounds);
    }

    if (values[CONDO_LOCATIONS_OBJECT_LABEL]) {
      selectLocation(values[CONDO_LOCATIONS_OBJECT_LABEL] as ICondoLocation);
    }

    if (values[CONDO_LOCATIONS_LABEL]) {
      selectLocationLabel(values[CONDO_LOCATIONS_LABEL] as string);
    }

    if (values[CONDO_DATES_LABEL]) {
      const dates: { startDate: string; endDate: string } = values[CONDO_DATES_LABEL] as {
        startDate: string;
        endDate: string;
      };
      const today = new Date();
      today.setHours(zero, zero, zero, zero);

      setDates(dates);

      const startDate = getDateCheckInOut(dates?.startDate);
      if (dates?.startDate && startDate && isBefore(startDate, today)) {
        setDates({ endDate: UNDEFINED_VALUE, startDate: UNDEFINED_VALUE });
        setSearchType(DateSearchTypeEnum.Strict);
      }
    }

    if (values[CONDO_IS_FLEXIBLE_LABEL]) {
      const value = values[CONDO_IS_FLEXIBLE_LABEL];
      setSearchType(
        value.toString() === `${one}` ? DateSearchTypeEnum.Flexible : DateSearchTypeEnum.Strict,
      );
    }
    if (values[CONDO_DATES_FLEXIBLE_LABEL]) {
      const selectedData: ICondoFlexibleDatePickerState = values[
        CONDO_DATES_FLEXIBLE_LABEL
      ] as ICondoFlexibleDatePickerState;
      const today = new Date();
      today.setHours(zero, zero, zero, zero);
      today.setDate(one);
      const months = selectedData?.selectedMonths.filter((dateString: string) => {
        const date = new Date(dateString);
        date.setHours(zero, zero, zero, zero);
        date.setDate(one);

        return !isBefore(date, today);
      });

      setFlexibleState({
        stayFor: selectedData?.stayFor,
        selectedMonths: months?.length ? months : [],
      });
    }

    if (!values[CONDO_DATES_FLEXIBLE_LABEL]) {
      setFlexibleState({
        stayFor: StayForEnum.Week,
        selectedMonths: [],
      });
    }

    if (values[CONDO_GUESTS_LABEL]) {
      setGuestsState(values[CONDO_GUESTS_LABEL] as ICondoGuestsState);
    }

    const session: ISessionKey = values[CONDO_SESSION_KEY] as ISessionKey;

    if (session && session.expireDate && getTimeout(session.expireDate) > zero) {
      setSessionKey(session);
      isReuse = true;
    }

    setTimeout(() => {
      const certificateIdFromState = (
        this.props.history.location.state as { certificateId?: string } | undefined
      )?.certificateId?.trim();

      if (
        certificateIdFromState &&
        !isWidget &&
        this.props.loginStore?.user?.userId &&
        isDisplayCertificates(this.props.loginStore?.account as IAccount)
      ) {
        void this.afterMountCondoCertificateSearch({ certificateId: certificateIdFromState, isReuse });
        return;
      }

      if (!condosStore.condos && session) {
        this.onSearch({ isReuse, isLoad: true });
      } else {
        const { history, loginStore } = this.props;
        
        const isDisableHomes = loginStore?.account?.isDisableHomes;
        const disableHomesRedirect = loginStore?.account?.disableHomesRedirect;
    
        if (isDisableHomes && !isWidget) {
          if (isEmpty(disableHomesRedirect)) {
            history.push(Routes.NotAuthorized);
          } else {
            window.location.replace(disableHomesRedirect as string);
          }
        }

      }
    }, 200);
  }

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    const certificateIdFromState = (
      this.props.history.location.state as { certificateId?: string } | undefined
    )?.certificateId?.trim();

    if (this.props.isWidget || !certificateIdFromState || this.condoCertificateRouteBootstrapped) {
      return;
    }

    if (!this.props.loginStore?.user?.userId) {
      return;
    }

    if (!isDisplayCertificates(this.props.loginStore?.account as IAccount)) {
      return;
    }

    const certificatesFinishedLoading =
      prevProps.certificatesStore.loading && !this.props.certificatesStore.loading;
    const userIdBecameAvailable =
      !prevProps.loginStore?.user?.userId && !!this.props.loginStore?.user?.userId;

    if (!certificatesFinishedLoading && !userIdBecameAvailable) {
      return;
    }

    const values = UrlUtils.getValues();
    const session: ISessionKey = values[CONDO_SESSION_KEY] as ISessionKey;
    const isReuse = !!(session && session.expireDate && getTimeout(session.expireDate) > zero);
    void this.afterMountCondoCertificateSearch({
      certificateId: certificateIdFromState,
      isReuse,
    });
  }

  onAnytimeSearchWarningClose = (_e: React.MouseEvent<HTMLElement, MouseEvent>, dontShowAgain: boolean) => {
    if (dontShowAgain) {
      disableAnytimeSearchWarning();
    }
    this.props.setIsAnytimeSearchWarningVisible(false);
  };

  notifyCertificateFullRedemptionIfNeeded = (): void => {
    const { condoFiltersStore, certificatesStore, condoStrictDatesStore, intl } = this.props;
    const certificateId = condoFiltersStore.certificateId?.trim();
    if (!certificateId) {
      return;
    }

    const { searchType, startDate, endDate } = condoStrictDatesStore;
    if (searchType === DateSearchTypeEnum.Flexible || !startDate || !endDate) {
      return;
    }

    const cert = findUserCertificateById(certificatesStore.data, certificateId);
    const certNights = getTotalNightsForCertificateItemType(cert, ItemTypeEnum.Condo);
    const selectedNights = getNights(startDate, endDate);
    if (selectedNights !== certNights) {
      Toaster.info(intl.formatMessage({ id: 'certificates.fullRedemption.toast' }), { autoClose: 10000 });
    }
  };

  onSearch = ({
    isReuse = false,
    isInit = true,
    isLoad = false,
    locationPickerOverride,
  }: OnSearchOptions = {}) => {
    const {
      isWidget,
      isExperiences,
      condoStrictDatesStore,
      condosLocationPickerStore,
      condoGuestsStore,
      condoFlexibleDatePickerStore,
      hotelsStore,
      loginStore,
      sharecompare,
      condosStore,
      intl,

      setIsSearch,
      getCondos,
      setShouldFocus,
      setPageNumber,
      resetFilters,
      setSearchType,
      resetFlexibleState,
      resetDates,
      onExperience,
      validateLocation,
      validateDates,
    } = this.props;

    const condosLocationPickerForRun: ICondosLocationPickerState =
      locationPickerOverride !== undefined
        ? { ...condosLocationPickerStore, ...locationPickerOverride }
        : condosLocationPickerStore;

    const { isDatesValid, isLocationValid, isValid, isDatesMaxError } = isCondoDataValid(
      condosLocationPickerForRun,
      condoStrictDatesStore,
    );

    const { selectedMonths } = condoFlexibleDatePickerStore;
    const { searchType, startDate, endDate } = condoStrictDatesStore;
    const { condoscompare, condoscompareSearch, condoscompareStartDate, condoscompareEndDate, condoscompareMonth } = sharecompare;
    const { adultsCount, kidsCount, bedroomsCount, includeStudio,prevAdultsCount,prevKidsCount,prevBedroomsCount,prevIncludeStudio } = condoGuestsStore;
    const isSameMonth = selectedMonths.length === condoscompareMonth?.length && selectedMonths.every((value, index) => value === condoscompareMonth[index]);
    const hasShareMultipleEnabled = GetMultipleCitiesEnabled(loginStore);
    const hasShareMultipleQuotesEnabled = GetMultipleQuotesEnabled(loginStore);
    if(hasShareMultipleQuotesEnabled){
      // keep data
    }else if(hasShareMultipleEnabled){
      if((adultsCount !== prevAdultsCount || kidsCount !== prevKidsCount || bedroomsCount !== prevBedroomsCount || includeStudio !== prevIncludeStudio )&& (condoscompare?.length > zero)){
          this.props.setclearCondoCompare();
      }
      if (searchType !== condoscompareSearch) {
        this.props.setcondoscompareSearch(searchType);
        this.props.setclearCondoCompare();
      }

      if (searchType !== 'Flexible') {
        if (startDate !== condoscompareStartDate) {
          this.props.setCondoCompareStartDate(startDate as string);
          this.props.setclearCondoCompare();
        }

        if (endDate !== condoscompareEndDate) {
          this.props.setCondoCompareEndDate(endDate as string);
          this.props.setclearCondoCompare();
        }
      }
      if (!isSameMonth) {
        this.props.setcondoscompareMonth(selectedMonths);
        this.props.setclearCondoCompare();
      }
    }else{
        this.props.setclearCondoCompare();
    }

     if (!isLocationValid) {
        validateLocation(intl.formatMessage({ id: 'condo.location.error' }));
      }
    if (!isDatesValid) {
      validateDates(
        intl.formatMessage({ id: isDatesMaxError ? 'maximum.date.range.search' : 'dates.error' }),
      );
    }

    if (isValid) {

      if (isWidget) {

        const { stayFor, selectedMonths } = condoFlexibleDatePickerStore;
        const { searchType, startDate, endDate } = condoStrictDatesStore;
        const { selectedLocation, selectedLocationLabel } = condosLocationPickerForRun;
        const { adultsCount, kidsCount, bedroomsCount, includeStudio } = condoGuestsStore;
        
        const isFlexible = searchType === DateSearchTypeEnum.Flexible;
        const guestParams = UrlUtils.getUrl(CONDO_GUESTS_LABEL, { adultsCount, kidsCount, bedroomsCount, includeStudio });
        const locationParams = `${CONDO_LOCATIONS_OBJECT_LABEL}=${Base64.encode(JSON.stringify(selectedLocation))}`;
        const locationLabelParams = UrlUtils.getUrl(CONDO_LOCATIONS_LABEL, selectedLocationLabel);
        const isFlexibleParams = UrlUtils.getUrl(CONDO_IS_FLEXIBLE_LABEL, isFlexible ? '1' : '0');
        const sessionParams = UrlUtils.getUrl(CONDO_SESSION_KEY, {
          value: v4(),
          isInvalid: true,
          expireDate: moment().format('yyyy-MM-DDTHH:mm:ss.SSSZ')
        } as ISessionKey);
        
        let datesParams;
        if (isFlexible) {
          datesParams = UrlUtils.getUrl(CONDO_DATES_FLEXIBLE_LABEL, { selectedMonths, stayFor });
        } else {
          datesParams = UrlUtils.getUrl(CONDO_DATES_LABEL, { startDate, endDate });
        }
    
        const accessToken = loginStore.account?.accessTokenDb;
        const hasPublicAccessToken = loginStore.account?.hasPublicAccessToken;
        const hasPublicValidToken = loginStore.account?.type !== LoginType.Public || !hasPublicAccessToken || !isEmpty(accessToken);

        const baseAddressSite = loginStore.account?.baseAddressSite;
        const accountName = loginStore.account?.name;

        const disableNewTabOpen = GetDisableNewTabOpen(this.props.loginStore.account, this.props.menuStore.items);

        const path = !isEmpty(baseAddressSite) ? baseAddressSite : import.meta.env.VITE_WIDGET_REDIRECT;
        const referenceNumberParam = !isEmpty(hotelsStore.referenceNumber) ? `${REFERENCE_NUMBER_LABEL}=${hotelsStore.referenceNumber}` : '';
        const agencyNumberParam = !isEmpty(hotelsStore.agencyNumber) ? `${AGENCY_NUMBER_LABEL}=${hotelsStore.agencyNumber}` : '';
        const tokenParam = hasPublicValidToken ? `${ACCESS_TOKEN_LABEL}=${accessToken}` : '';

        const isCondoLocation = selectedLocation?.locationType === CondoLocationsEnum.GenericCondo;

        let url;
        if (isCondoLocation) {
          url = `${path}${accountName}${Routes.Condo}/${selectedLocation?.id}?${guestParams}&${tokenParam}&${locationParams}&${isFlexibleParams}&${locationLabelParams}&${datesParams}&${sessionParams}&${referenceNumberParam}&${agencyNumberParam}`;
        } else {
          url = `${path}${accountName}${Routes.CondoSearch}?${guestParams}&${tokenParam}&${locationParams}&${isFlexibleParams}&${locationLabelParams}&${datesParams}&${sessionParams}&${referenceNumberParam}&${agencyNumberParam}`;
        }

        if (disableNewTabOpen) {
          window.location.replace(url);
        } else {
          window.open(url, '_blank');
        }

      } else {
        const { shouldFocus } = condosLocationPickerStore;
        const { selectedLocation } = condosLocationPickerForRun;

        if (!isExperiences && !isLoad && condoStrictDatesStore.searchType === DateSearchTypeEnum.Flexible) {
          setSearchType(DateSearchTypeEnum.Flexible);
        }
    
        if (!shouldFocus && selectedLocation) {
          setPageNumber();
          setIsSearch();
          this.setState({ ...this.state, isCollapse: !this.state.isCollapse });
    
          if (!isInit) {
            resetFilters();
            UrlUtils.setUrl(CONDO_FILTERS_LABEL, null);
          }
    
          if (isWidget) {
    
          } else if (isExperiences) {
            if (onExperience) {
              onExperience();
            }
          } else {
            if (condosStore.isSearch) {
              this.notifyCertificateFullRedemptionIfNeeded();
            }

            getCondos(isReuse);
    
            if (condoStrictDatesStore.searchType === DateSearchTypeEnum.Strict) {
              resetFlexibleState();
            } else {
              resetDates();
            }
          
            const contentWrapper = document.querySelector('.condo-result-wrapper__content');
    
            if (contentWrapper) {
              contentWrapper.scroll(zero, zero);
              window.scrollTo(zero, zero);
            }
          }
        } else {
          if (!isInit) {
            setShouldFocus();
          }
        }  
      }
    }

  };




  onToggle = () => {
    this.setState({ ...this.state, isCollapse: !this.state.isCollapse });
  };

  render(): React.ReactNode {
    const {
      isWidget,
      isExperiences,
      condosStore,
      loginStore,
      hideTitle,
      title,
      hideMessage,
      message,
      hideSearchSelection,
      widgetBackgroundColor,
      excludeCondosSelection,
      excludeHotelsSelection,
      excludeVacationsSelection,
      widgetOriginalType,
      forceVertical,
      borderRadius,
      disableLocationSearch,
      condoGuestsStore,
    } = this.props;
    const { isSearch, condos } = condosStore;
    const { isCollapse } = this.state;

    const { account, user } = loginStore;

    const { adultsCount, kidsCount, bedroomsCount, includeStudio } = condoGuestsStore;

    const searchTitle = getPreferenceFromAccount(account as IAccount, CONDOS_SEARCH_TITLE_FIELD_KEY);
    const searchMessage = getPreferenceFromAccount(account as IAccount, CONDOS_SEARCH_MESSAGE_FIELD_KEY);
    const backgroundImage = getPreferenceFileUrlFromAccount(account as IAccount, CONDOS_BACKGROUND_PHOTO_FIELD_KEY);

    const hasPublicAccessToken = account?.hasPublicAccessToken;
    const isRSITemplate = account?.isRSITemplate;
    const hasPublicValidToken = account?.type !== LoginType.Public || !hasPublicAccessToken || !isEmpty(loginStore.accessToken);


    /*
    let withImage = false;
    const styleAccount: any = {};   
    const styleMain: any = {};   
    if (!isExperiences) {  
      if (isWidget && widgetBackgroundColor) {
        styleAccount.background = widgetBackgroundColor;
        styleMain.background = 'none';
      } else {
        const background = getPreferenceFromAccount(account, BACKGROUND_COLOR_FIELD_KEY);
        const logoImage = backgroundImage ? 
                            backgroundImage : 
                            RSI_HOME_NAMES.includes(account?.name || '')? 
                                HotelBackground : 
                                background ? 
                                    null : 
                                    isWidget ? null : CondoBackground;

        if (background && !logoImage) {
          styleAccount.background = background;
          styleMain.background = 'none';
        } 
  
        if (logoImage) {
          if (!isSearch) {
            withImage = true;
            styleMain.background = 'none';
          }
  
          styleAccount.backgroundImage = isRSITemplate || condos ?
            !isSearch && `url(${logoImage})` :
            isWidget ?
              !isSearch && `url(${logoImage})` :
              !isSearch && `linear-gradient(rgba(255,255,255,0) 80%, rgba(255,255,255,1)), url(${logoImage})`;
        }  
      }
    } 

    if (!isEmpty(borderRadius)) {
      try {
        const border = parseInt(borderRadius);
        styleAccount.borderRadius = `${border}px`;
      } catch(e) {
        console.error(e);
      }
    }
    */

    const values = UrlUtils.getValues();

    const searchTitleFinal = isWidget && !isEmpty(title) ? title : searchTitle;
    const searchMessageFinal = isWidget && !isEmpty(message) ? message : searchMessage;

    const { styleAccount, styleMain, withImage } = GetStyles(account, backgroundImage, borderRadius, HotelBackground, CondoBackground, isSearch, isExperiences, isWidget, widgetBackgroundColor, condos?.length);

    const styleTitle = !isEmpty(account?.homeTitleColor) ? { color: account?.homeTitleColor } : {};

    return (
      <div
        className={`condo-search condo-engine ${(isWidget || isExperiences) ? 'widget' : ''}  ${(!isRSITemplate && !condos) ? 'travcoding-template-main' : ''} ${(isSearch && !(isWidget || isExperiences)) ? 'after-search' : ''} ${isCollapse ? 'toggle-condo-search-info' : ''}`}
        style={styleMain}
      >
        {isDisplayCertificates(account as IAccount) && (
          <UserCertificatesFetcher
            email={user?.email}
            organizationId={user?.userAdditionalData?.organizationId}
          />
        )}
        <div className={`search-wrapper__image ${withImage ? 'with-image' : ''} ${isWidget ? 'widget' : ''}`} style={styleAccount}></div>

        <div className={`condo-search__wrapper ${backgroundImage ? 'background-image' : ''} ${(!isRSITemplate && !condos) ? 'travcoding-template' : ''} ${(isWidget || isExperiences) ? 'widget' : ''}`}>
          {!isExperiences ? (
            <>
              {(!isWidget || (isWidget && !hideTitle)) ? (
                <h1 className={`condo-search__header secondary-font ${isWidget ? 'widget' : ''} ${(isWidget && hideMessage) ? 'widget-hide' : ''}`} style={{ ...styleTitle }}>
                  {isEmpty(searchTitleFinal) ? (<FormattedMessage id="condo.header" />) : searchTitleFinal}
                </h1>) : null}

              {(!isWidget || (isWidget && !hideMessage)) ? (
                <div className={`condo-search__header-small ${(!isRSITemplate && !condos) ? 'travcoding-template' : ''} ${isWidget ? 'widget' : ''} ${(isWidget && hideTitle) ? 'widget-hide' : ''}`} style={{ ...styleTitle }}>
                  {isEmpty(searchMessageFinal) ? (<FormattedMessage id="condo.header.small" />) : searchMessageFinal}
                </div>) : null}
            </>) : null}

          <div className={`condo-search__search-section ${(isWidget || isExperiences) ? 'widget' : ''}`}>
            {(hasPublicValidToken || isWidget) && !isExperiences && (!isCollapse || isEmpty(values)) && !condos && !hideSearchSelection && (
              <SearchSelection
                type={'Condos'}
                isWidget={isWidget}
                widgetOriginalType={widgetOriginalType}
                onWidgetSelectionChange={this.props.onWidgetSelectionChange}
                excludeCondosSelection={excludeCondosSelection}
                excludeHotelsSelection={excludeHotelsSelection}
                excludeVacationsSelection={excludeVacationsSelection}
              />)}

            {(hasPublicValidToken || isWidget) && (
              <div className={`condo-search__search-top ${forceVertical ? 'vertical' : ''} ${(isWidget || isExperiences) ? 'widget' : ''}`}>
                <CondoLocationPicker
                  key="location-picker"
                  isExperiences={isExperiences}
                  openOnClick={true}
                  disable={disableLocationSearch}
                  onFireSearch={() => {
                    this.props.setSearchType(DateSearchTypeEnum.Flexible);
                    this.props.setDates({ endDate: UNDEFINED_VALUE, startDate: UNDEFINED_VALUE });
                    this.props.setGuestsState({ 
                      ...CondoGuestInitialState, 
                      prevAdultsCount: adultsCount,
                      prevKidsCount: kidsCount,
                      prevBedroomsCount: bedroomsCount,
                      prevIncludeStudio: includeStudio 
                    });
                    this.props.setFlexibleState({ stayFor: StayForEnum.Week, selectedMonths: [] });
                    if (!isWidget) {
                      setTimeout(() => this.onSearch({ isInit: false }), 200);
                    }
                  }}
                />
                <Responsive>
                  <CondoStrictDatePicker
                    key={`condo-strict-dates-${this.state.strictDatePickerRemountKey}`}
                    isExperiences={isExperiences}
                  />
                </Responsive>

                <CondoGuestsPicker isExperiences={isExperiences} />

                <BlueButton onClick={() => this.onSearch({ isInit: false})} style={{ height: '60px', maxWidth: isSpanish() ? '230px' : '190px' }}>
                  {isSearch ? (
                    <>
                      <FontAwesomeIcon icon={faRotate} />
                      <FormattedMessage id="update.search.your.hotel" />
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faSearch} />
                      <FormattedMessage id="find.your.condo" />
                    </>
                  )}
                </BlueButton>
              </div>)}
            {(!hasPublicValidToken && !isWidget) && (<AccessToken />)}
          </div>
          {isCollapse && <CondoSearchInfo onToggle={this.onToggle} />}
          {isSearch && !isCollapse && !isWidget && (
            <Button
              className="condo-search__toggle-condo-search-info"
              onClick={this.onToggle}
              type="text"
            >
              <FormattedMessage id="cancel" />
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    condosStore: state.condosStore,
    condosLocationPickerStore: state.condosLocationPickerStore,
    condoStrictDatesStore: state.condoStrictDatesStore,
    condoGuestsStore: state.condoGuestsStore,
    condoFlexibleDatePickerStore: state.condoFlexibleDatePickerStore,
    condoFiltersStore: state.condoFiltersStore,
    certificatesStore: state.certificatesStore,
    hotelsStore: state.hotelsStore,
    loginStore: state.loginStore,
    menuStore: state.navigationMenuStore,
    sharecompare: state.compareStore,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  validateLocation: (error: string) => {
    dispatch(condosLocationPickerActions.setError(error));
  },
  validateDates: (error: string) => {
    dispatch(condoStrictDatesActions.setError(error));
  },
  setIsSearch: () => {
    dispatch(condosActions.setIsSearch(true));
  },
  setSessionKey: (sessionKey: ISessionKey) => {
    dispatch(condosActions.setCondoSessionKey(sessionKey));
  },
  setPageNumber: () => {
    dispatch(condosActions.setPageNumber(DEFAULT_PAGE_NUMBER));
  },
  setIsAnytimeSearchWarningVisible: (visible: boolean) => {
    dispatch(condosActions.setIsAnytimeSearchWarningVisible(visible));
  },
  selectLocationLabel: (label: string) => {
    dispatch(condosLocationPickerActions.selectLocationLabel(label));
  },
  selectLocation: (location: ICondoLocation) => {
    dispatch(condosLocationPickerActions.selectLocation(location));
  },
  setGuestsState: (state: ICondoGuestsState) => {
    dispatch(condoGuestsActions.setState(state));
  },
  setFlexibleState: (state: ICondoFlexibleDatePickerState) => {
    dispatch(condoFlexibleDatePickerActions.setState(state));
  },
  setSearchType: (type: DateSearchTypeEnum) => {
    dispatch(condoStrictDatesActions.setSearchType(type));
  },
  setDates: (dates: { startDate: string; endDate: string }) => {
    dispatch(condoStrictDatesActions.setDates(dates));
  },
  setBounds: (bounds: IBounds) => {
    dispatch(condosActions.setBounds(bounds));
  },
  getCondos: (isReuse: boolean) => {
    dispatch(getCondos(SearchTypeEnum.NewSearch, isReuse));
  },
  setShouldFocus: () => {
    dispatch(condosLocationPickerActions.setShouldFocus(true));
  },
  setFilters: (filters: ICondoFiltersState) => {
    dispatch(condoFiltersActions.setFilters(filters));
  },
  resetFilters: () => {
    dispatch(condoFiltersActions.resetFilters());
  },
  setIsWidget: (isWidget: boolean) => {
    dispatch(condosActions.setIsWidget(isWidget));
  },
  resetDates: () => {
    dispatch(condoStrictDatesActions.resetDates());
  },
  resetFlexibleState: () => {
    dispatch(condoFlexibleDatePickerActions.resetState());
  },

  setCondoCompareStartDate: (value: string) => {
    dispatch(compareActions.setCondoCompareStartDate(value as string));
  },
  setCondoCompareEndDate: (value: string) => {
    dispatch(compareActions.setCondoCompareEndDate(value as string));
  },
  setcondoscompareMonth: (value: string[]) => {
    dispatch(compareActions.setcondoscompareMonth(value as string[]));
  },
  setcondoscompareSearch: (value: string) => {
    dispatch(compareActions.setcondoscompareSearch(value as string));
  },
  setclearCondoCompare: () => {
    dispatch(compareActions.setclearCondoCompare());
  },
  setclearFullCondosCompare: () => {
    dispatch(compareActions.setclearFullCondosCompare());
  },
  setCondoCertificateId: (value: string) => {
    dispatch(condoFiltersActions.setCertificateId(value));
  },
  setCondoCertificateItemId: (value: string) => {
    dispatch(condoFiltersActions.setCertificateItemId(value));
  },
  setCondoCertificateAllowAutoFill: (allow: boolean) => {
    dispatch(condoFiltersActions.setCondoCertificateAllowAutoFill(allow));
  },
});

export const CondoSearch = connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(CondoSearchComponent)));
